import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "@/lib/utils";

/**
 * A single-line text field: composer, list name, and whatever comes next.
 *
 * Pill radius and 52px, to match the full-width button it sits above. Focus is
 * a 2px accent edge drawn as border + inset ring, so the text does not shift
 * by the extra pixel. `text-body` is not a style choice — anything under 16px
 * makes iOS Safari zoom the viewport on focus.
 *
 * Rewritten off shadcn's generated input for the same reason as the button.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-13 w-full min-w-0 rounded-pill border border-line bg-paper px-5 text-body text-ink outline-none transition-colors placeholder:text-muted focus:border-accent focus:ring-1 focus:ring-accent focus:ring-inset disabled:opacity-40",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
